import type { LaunchDarklyApp } from './constants';

export type LaunchDarklyUserInput = {
  id?: string | null;
  email?: string | null;
  userType?: string | null;
  defaultPartnerId?: string | null;
  selectedPartner?: { id?: string | null } | null;
};

export const buildLaunchDarklyContext = (app: LaunchDarklyApp, user?: LaunchDarklyUserInput | null) => {
  const userId = user?.id?.trim();

  if (!user || !userId) {
    return {
      kind: 'user' as const,
      key: `anonymous-${app}`,
      anonymous: true,
      app,
    };
  }

  const email = user.email?.trim();
  const partnerId = user.selectedPartner?.id ?? user.defaultPartnerId ?? undefined;

  return {
    kind: 'user' as const,
    key: userId,
    anonymous: false,
    app,
    ...(email ? { email } : {}),
    ...(user.userType ? { userType: user.userType } : {}),
    ...(partnerId ? { partnerId } : {}),
  };
};
